import { Directive } from '@angular/core';

@Directive({
    selector: '[appSortableListFields]',
    standalone: false
})
export class SortableListFieldsDirective {}
